import helper from './helper'

const getEducationUrlWithParameters = helper.getEducationUrlWithParameters
const allowedEducationOrderUrl = helper.allowedEducationOrderUrl
export default {
  getEducationUrlWithParameters,
  /**
   * Базовая функция для построения урл
   */
  getByRecievedUrlData: (url, gets = null) => getEducationUrlWithParameters(
    /**
     * Построение урл из предопределенного объекта урл
     * @param {Object} url - Объект конфигурации url
     * @param {Object} gets - Допальнительные query параметры
     * @return {String} url - Строка url
     */
    url.basename,
    url.action,
    url.params,
    gets
  ),
  EDUCATION: {
    ALLOWED: () => allowedEducationOrderUrl(
      /**
       * Функция для построения URL из предопределенного объекта URL
       * @param {Object} url - объект конфигурации URL
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} строка URL
       */
      'student|students|student',
      "get",
    ),
    ADVANCED_TRAINING: {
      LIST:
                (gets = null) => getEducationUrlWithParameters(
                  /**
                   * Получает допустимые образования
                   * @returns {string} URL для получения допустимых образований
                   */
                  'connectors|relations|achievement|documents-list',
                  'list',
                  null,
                  gets
                ),
      CREATE:
                (gets = null) => getEducationUrlWithParameters(
                  /**
                   * Создает новый курс дополнительного образования
                   * @param {Object} gets - дополнительные query параметры (опционально)
                   * @returns {string} URL для создания курса
                   */
                  'connectors|relations|achievement|documents-list',
                  'create',
                  null,
                  gets
                ),
      DELETE:
                (id, gets = null) => getEducationUrlWithParameters(
                  /**
                   * Удаляет курс дополнительного образования
                   * @param {string|number} id - идентификатор курса
                   * @param {Object} gets - дополнительные query параметры (опционально)
                   * @returns {string} URL для удаления курса
                   */
                  'connectors|relations|achievement|documents-detail',
                  'destroy',
                  { id },
                  gets
                ),
      UPDATE:
                (id, gets = null) => getEducationUrlWithParameters(
                  /**
                   * Обновляет курс дополнительного образования
                   * @param {string|number} id - идентификатор курса
                   * @param {Object} gets - дополнительные query параметры (опционально)
                   * @returns {string} URL для обновления курса
                   */
                  'connectors|relations|achievement|documents-detail',
                  'update',
                  { id },
                  gets
                )
    }
  }
}
